module.exports = __webpack_public_path__ + "img/1480854163.e0dd5bc3.jpg";